import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';
import { transport } from 'app-react-query/public-transport';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AuthAndClient = {
  authentication_type?: Maybe<AuthenticationType>;
  client?: Maybe<Client>;
  existing_user: Scalars['Boolean'];
};

export enum AuthenticationType {
  Auth = 'auth',
  Passwordless = 'passwordless',
  Sso = 'sso'
}

export type Capability = {
  active?: Maybe<Scalars['Boolean']>;
  capability_string: Scalars['String'];
};

export type Client = {
  allow_user_invites: Scalars['Boolean'];
  allow_user_signup: Scalars['Boolean'];
  authentication_type: AuthenticationType;
  client_status: ClientStatus;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  default_language?: Maybe<Scalars['String']>;
  default_timezone?: Maybe<Scalars['String']>;
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  public_post_details?: Maybe<Scalars['Boolean']>;
  public_post_force_login?: Maybe<Scalars['Boolean']>;
  public_post_page?: Maybe<Scalars['Boolean']>;
  social_media_policy?: Maybe<Scalars['String']>;
  social_media_policy_enabled?: Maybe<Scalars['Boolean']>;
  social_media_policy_title?: Maybe<Scalars['String']>;
  social_media_policy_url?: Maybe<Scalars['String']>;
  sso_configuration?: Maybe<SsoConfiguration>;
  subdomain?: Maybe<Scalars['String']>;
  support_multiple_languages: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ClientInvitation = {
  accepted_at?: Maybe<Scalars['Int']>;
  accepted_by_user_id?: Maybe<Scalars['ID']>;
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  email_address: Scalars['String'];
  email_from_address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invitation_status: ClientInvitationStatus;
  last_sent_at?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  retries?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['Int'];
};

/**   Client invitations */
export enum ClientInvitationStatus {
  Accepted = 'accepted',
  Active = 'active',
  Deleted = 'deleted'
}

export type ClientRequest = {
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  email_address: Scalars['String'];
  id: Scalars['ID'];
  request_status: ClientRequestStatus;
  updated_at: Scalars['Int'];
};

/**   Client requests */
export enum ClientRequestStatus {
  Accepted = 'accepted',
  Active = 'active',
  Rejected = 'rejected'
}

export enum ClientStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ContentCommentary = {
  commentary: Scalars['String'];
  network: Network;
};

export type ContentObject = {
  body?: Maybe<Scalars['String']>;
  content_hash?: Maybe<Scalars['String']>;
  instagram_metadata?: Maybe<InstagramMetadata>;
  media?: Maybe<MediaObject>;
  media_type?: Maybe<Scalars['String']>;
  metadata_keys?: Maybe<Array<Maybe<MetadataKey>>>;
  photos?: Maybe<Array<Maybe<S3Object>>>;
  post_type: PostType;
  primary_url_metadata_image?: Maybe<Scalars['Int']>;
  reddit_metadata?: Maybe<RedditMetadata>;
  title?: Maybe<Scalars['String']>;
  /**   TODO: Check with brandon to see if this needed */
  tweet_metadata?: Maybe<TweetMetadata>;
  url?: Maybe<Scalars['String']>;
  url_metadata?: Maybe<UrlMetadata>;
  video_url?: Maybe<Scalars['String']>;
  youtube_metadata?: Maybe<YoutubeMetadata>;
};

export type CreateClientRequestInput = {
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
};

export type GlobalSettings = {
  accepting_signups?: Maybe<Scalars['Boolean']>;
};

export type InstagramLocation = {
  has_public_page: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InstagramMedia = {
  bucket?: Maybe<Scalars['String']>;
  display_url?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  is_video: Scalars['Boolean'];
  shortcode: Scalars['String'];
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
  width?: Maybe<Scalars['Int']>;
};

export type InstagramMetadata = {
  caption?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_ad: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  location?: Maybe<InstagramLocation>;
  media: Array<Maybe<InstagramMedia>>;
  owner: InstagramOwner;
  shortcode: Scalars['String'];
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
  taken_at_timestamp: Scalars['Int'];
};

/**   Content / Instagram metadata */
export type InstagramOwner = {
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_bucket?: Maybe<Scalars['String']>;
  profile_pic_file_key?: Maybe<Scalars['String']>;
  profile_pic_height?: Maybe<Scalars['Int']>;
  profile_pic_url?: Maybe<Scalars['String']>;
  profile_pic_width?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  username: Scalars['String'];
};

export type InstagramTaggedUser = {
  id: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type MediaObject = {
  video?: Maybe<S3VideoObject>;
};

export enum MetadataKey {
  InstagramMetadata = 'instagram_metadata',
  RedditMetadata = 'reddit_metadata',
  TweetMetadata = 'tweet_metadata',
  UrlMetadata = 'url_metadata',
  YoutubeMetadata = 'youtube_metadata'
}

/**   Start Content */
export type MinimalUserProfile = {
  /**   id: ID! */
  full_name?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
};

export type Mutation = {
  /**   Create a client request */
  createClientRequest: ClientRequest;
  createPublicShareInfo: PublicShareInfo;
  deletePublicSocialConnection: Status;
  ensureInvitedUserConfirmed?: Maybe<ClientInvitation>;
  publicShareContent?: Maybe<SharedContentResults>;
  sendForgotPasswordEmail: Scalars['String'];
  sendSignOnEmail: Scalars['String'];
  signOnByInvitation: SignOnResponse;
  unsubscribeCE: Scalars['Boolean'];
};


export type MutationCreateClientRequestArgs = {
  data: CreateClientRequestInput;
};


export type MutationCreatePublicShareInfoArgs = {
  access_key: Scalars['String'];
  content_id: Scalars['ID'];
};


export type MutationDeletePublicSocialConnectionArgs = {
  access_key: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationEnsureInvitedUserConfirmedArgs = {
  id: Scalars['ID'];
};


export type MutationPublicShareContentArgs = {
  access_key: Scalars['String'];
  content_id: Scalars['ID'];
  items: Array<InputMaybe<ShareContentInput>>;
  source?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationSendForgotPasswordEmailArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
};


export type MutationSendSignOnEmailArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
};


export type MutationSignOnByInvitationArgs = {
  invitation_id: Scalars['ID'];
};


export type MutationUnsubscribeCeArgs = {
  email_address: Scalars['String'];
};

export enum Network {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Msteams = 'msteams',
  Slack = 'slack',
  Twitter = 'twitter',
  Xing = 'xing'
}

export enum PostType {
  Instagram = 'instagram',
  Manual = 'manual',
  Quickshare = 'quickshare',
  Tweet = 'tweet',
  Url = 'url',
  Youtube = 'youtube'
}

export type PublicContent = {
  click_count?: Maybe<Scalars['Int']>;
  comment_count?: Maybe<Scalars['Int']>;
  commentary?: Maybe<Array<Maybe<ContentCommentary>>>;
  content_id: Scalars['ID'];
  content_object: ContentObject;
  created_at: Scalars['Int'];
  engage_count?: Maybe<Scalars['Int']>;
  engagement_count?: Maybe<Scalars['Int']>;
  is_engageable?: Maybe<Scalars['Boolean']>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  lock_commentary?: Maybe<Scalars['Boolean']>;
  publish_at: Scalars['Int'];
  reaction_count?: Maybe<Scalars['Int']>;
  share_count?: Maybe<Scalars['Int']>;
  /** @deprecated Field is deprecated! */
  sharing_count?: Maybe<Scalars['Int']>;
  user?: Maybe<MinimalUserProfile>;
};

export type PublicEnv = {
  REACT_APP_SEGMENT_ANDROID_KEY?: Maybe<Scalars['String']>;
  REACT_APP_SEGMENT_IOS_KEY?: Maybe<Scalars['String']>;
};

export type PublicShareInfo = {
  shortened_urls?: Maybe<ShortenedUrLs>;
};

export type Query = {
  /**   Get active client by attr */
  getActiveClientByAttr?: Maybe<Client>;
  getAuthAndClient: AuthAndClient;
  /**   Get a client object */
  getClientByEmailDomain?: Maybe<Client>;
  /**   Get a client invitation */
  getClientInvitation?: Maybe<ClientInvitation>;
  getClientsCapabilities?: Maybe<Array<Maybe<Capability>>>;
  getGlobalSettings?: Maybe<GlobalSettings>;
  /**   Retrieve public content */
  getPublicContent?: Maybe<PublicContent>;
  getPublicEnv?: Maybe<PublicEnv>;
  listPublicSocialConnections: SocialAccountConnectionsList;
};


export type QueryGetActiveClientByAttrArgs = {
  key: UniqueClientKey;
  value: Scalars['String'];
};


export type QueryGetAuthAndClientArgs = {
  email_address: Scalars['String'];
};


export type QueryGetClientByEmailDomainArgs = {
  email_domain: Scalars['String'];
};


export type QueryGetClientInvitationArgs = {
  id: Scalars['ID'];
};


export type QueryGetClientsCapabilitiesArgs = {
  client_id: Scalars['ID'];
};


export type QueryGetPublicContentArgs = {
  client_id: Scalars['ID'];
  content_id: Scalars['ID'];
};


export type QueryGetPublicEnvArgs = {
  env_id: Scalars['ID'];
};


export type QueryListPublicSocialConnectionsArgs = {
  access_key?: InputMaybe<Scalars['String']>;
};

/**   Reddit Metadata */
export type RedditMetadata = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: Maybe<Scalars['Int']>;
  oembed_description?: Maybe<Scalars['String']>;
  oembed_height?: Maybe<Scalars['Int']>;
  oembed_html?: Maybe<Scalars['String']>;
  oembed_html_secure?: Maybe<Scalars['String']>;
  oembed_provider_name?: Maybe<Scalars['String']>;
  oembed_provider_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_bucket?: Maybe<Scalars['String']>;
  oembed_thumbnail_file_key?: Maybe<Scalars['String']>;
  oembed_thumbnail_height?: Maybe<Scalars['Int']>;
  oembed_thumbnail_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_width?: Maybe<Scalars['Int']>;
  oembed_title?: Maybe<Scalars['String']>;
  oembed_type?: Maybe<Scalars['String']>;
  oembed_width?: Maybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  preview_image_bucket?: Maybe<Scalars['String']>;
  preview_image_file_key?: Maybe<Scalars['String']>;
  preview_image_height?: Maybe<Scalars['Int']>;
  preview_image_url?: Maybe<Scalars['String']>;
  preview_image_width?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  selftext?: Maybe<Scalars['String']>;
  selftext_html?: Maybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subreddit_type: Scalars['String'];
  subscribers?: Maybe<Scalars['Int']>;
  thumbnail_bucket?: Maybe<Scalars['String']>;
  thumbnail_file_key?: Maybe<Scalars['String']>;
  thumbnail_height?: Maybe<Scalars['Int']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  thumbnail_width?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
  video_duration?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_url?: Maybe<Scalars['String']>;
  video_width?: Maybe<Scalars['Int']>;
};

/**   Images */
export type S3Object = {
  bucket: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  region: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type S3VideoObject = {
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  playlist?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ShareContentDestination {
  Direct = 'direct',
  Email = 'email',
  Facebook = 'facebook'
}

export type ShareContentInput = {
  destination?: InputMaybe<ShareContentDestination>;
  group_id?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['String']>;
  share_at?: InputMaybe<Scalars['Int']>;
  share_type?: InputMaybe<ShareType>;
  user_commentary?: InputMaybe<Scalars['String']>;
};

export enum ShareType {
  Auto = 'auto',
  Frontend = 'frontend',
  Now = 'now',
  Scheduled = 'scheduled'
}

export type SharedContentItem = {
  error?: Maybe<Scalars['String']>;
  network_id: Scalars['ID'];
  share_session_id: Scalars['ID'];
  shortened_url?: Maybe<ShortenedUrlItem>;
  status: SharedStatus;
  url?: Maybe<Scalars['String']>;
};

export type SharedContentResults = {
  results?: Maybe<Array<SharedContentItem>>;
};

export enum SharedStatus {
  Failed = 'failed',
  Pending = 'pending',
  Successful = 'successful'
}

export type ShortenedUrLs = {
  direct?: Maybe<ShortenedUrlItem>;
  email?: Maybe<ShortenedUrlItem>;
  facebook?: Maybe<ShortenedUrlItem>;
  linkedin?: Maybe<ShortenedUrlItem>;
  twitter?: Maybe<ShortenedUrlItem>;
};

export type ShortenedUrlItem = {
  id?: Maybe<Scalars['String']>;
  short_link?: Maybe<Scalars['String']>;
};

export type SignOnResponse = {
  client: Client;
  invitation?: Maybe<ClientInvitation>;
  token?: Maybe<Scalars['String']>;
};

export type SocialAccount = {
  expires_soon: Scalars['Boolean'];
  id: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  profile_name?: Maybe<Scalars['String']>;
  profile_url?: Maybe<Scalars['String']>;
  provider: Network;
  reach?: Maybe<Scalars['Int']>;
};

export type SocialAccountConnectionsList = {
  access_key: Scalars['String'];
  count: Scalars['Int'];
  items: Array<SocialAccount>;
};

export type SsoConfiguration = {
  app_client_id?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  identity_pool_id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  redirect_sign_out?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_pool_id?: Maybe<Scalars['String']>;
};

export type Status = {
  status: Scalars['Boolean'];
};

/**   Content / Tweet Metadata fields */
export type TweetHashtag = {
  text: Scalars['String'];
};

export type TweetHashtagInput = {
  text: Scalars['String'];
};

export type TweetMedia = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMediaInput = {
  media_url_https?: InputMaybe<Scalars['String']>;
  media_url_original?: InputMaybe<Scalars['String']>;
  media_url_proxy?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMetadata = {
  created_at?: Maybe<Scalars['String']>;
  favorite_count?: Maybe<Scalars['Int']>;
  hashtags?: Maybe<Array<Maybe<TweetHashtag>>>;
  id_str: Scalars['String'];
  in_reply_to_status_id_str?: Maybe<Scalars['String']>;
  in_reply_to_user_id_str?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<TweetMedia>>>;
  place?: Maybe<TweetPlace>;
  possibly_sensitive?: Maybe<Scalars['Boolean']>;
  retweet_count?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  urls?: Maybe<Array<Maybe<TweetUrl>>>;
  user: TweetUser;
  user_mentions?: Maybe<Array<Maybe<TweetUserMention>>>;
};

export type TweetPlace = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetPlaceInput = {
  country?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  place_type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TweetUrl = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUrlInput = {
  display_url?: InputMaybe<Scalars['String']>;
  expanded_url?: InputMaybe<Scalars['String']>;
};

export type TweetUser = {
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  id_str: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  protected?: Maybe<Scalars['Boolean']>;
  screen_name: Scalars['String'];
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserInput = {
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  followers_count?: InputMaybe<Scalars['Int']>;
  friends_count?: InputMaybe<Scalars['Int']>;
  id_str: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  profile_image_url_https?: InputMaybe<Scalars['String']>;
  profile_image_url_original?: InputMaybe<Scalars['String']>;
  profile_image_url_proxy?: InputMaybe<Scalars['Boolean']>;
  protected?: InputMaybe<Scalars['Boolean']>;
  screen_name: Scalars['String'];
  statuses_count?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type TweetUserMention = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

export type TweetUserMentionInput = {
  id_str?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  screen_name?: InputMaybe<Scalars['String']>;
};

/**   Clients */
export enum UniqueClientKey {
  EmailDomain = 'email_domain',
  Id = 'id',
  Provider = 'provider',
  Subdomain = 'subdomain'
}

export type UrlMetadata = {
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<UrlMetadataImage>>>;
  media?: Maybe<UrlMetadataMedia>;
  original_url?: Maybe<Scalars['String']>;
  provider_display?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_url?: Maybe<Scalars['String']>;
  safe?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type: UrlMetadataType;
  url?: Maybe<Scalars['String']>;
};

/**   Content / URL metadata fields */
export type UrlMetadataImage = {
  bucket?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  url_original?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export type UrlMetadataMedia = {
  bucket?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  html?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  url_original?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export enum UrlMetadataType {
  Audio = 'audio',
  Html = 'html',
  Image = 'image',
  Unknown = 'unknown',
  Video = 'video'
}

/**   Content / Youtube  Metadata fields */
export type YoutubeMetadata = {
  channel_country?: Maybe<Scalars['String']>;
  channel_description?: Maybe<Scalars['String']>;
  channel_id?: Maybe<Scalars['String']>;
  channel_thumbnail_bucket?: Maybe<Scalars['String']>;
  channel_thumbnail_file_key?: Maybe<Scalars['String']>;
  channel_thumbnail_height?: Maybe<Scalars['Int']>;
  channel_thumbnail_original_url?: Maybe<Scalars['String']>;
  channel_thumbnail_width?: Maybe<Scalars['Int']>;
  channel_title?: Maybe<Scalars['String']>;
  channel_url?: Maybe<Scalars['String']>;
  video_definition?: Maybe<Scalars['String']>;
  video_description?: Maybe<Scalars['String']>;
  video_dimension?: Maybe<Scalars['String']>;
  video_duration?: Maybe<Scalars['String']>;
  video_id: Scalars['String'];
  video_player?: Maybe<Scalars['String']>;
  video_projection?: Maybe<Scalars['String']>;
  video_published_at?: Maybe<Scalars['Int']>;
  video_thumbnail_bucket?: Maybe<Scalars['String']>;
  video_thumbnail_file_key?: Maybe<Scalars['String']>;
  video_thumbnail_height?: Maybe<Scalars['Int']>;
  video_thumbnail_original_url?: Maybe<Scalars['String']>;
  video_thumbnail_width?: Maybe<Scalars['Int']>;
  video_title?: Maybe<Scalars['String']>;
  video_url: Scalars['String'];
};

export type ClientCommonFragment = { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, public_post_force_login?: boolean | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ClientPublicFragment = { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, public_post_force_login?: boolean | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type CreatePublicShareInfoMutationVariables = Exact<{
  access_key: Scalars['String'];
  content_id: Scalars['ID'];
}>;


export type CreatePublicShareInfoMutation = { createPublicShareInfo: { shortened_urls?: { email?: { short_link?: string | null | undefined } | null | undefined, direct?: { short_link?: string | null | undefined } | null | undefined, facebook?: { short_link?: string | null | undefined } | null | undefined } | null | undefined } };

export type EnsureInvitedUserConfirmedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnsureInvitedUserConfirmedMutation = { ensureInvitedUserConfirmed?: { id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number } | null | undefined };

export type PublicShareContentMutationVariables = Exact<{
  content_id: Scalars['ID'];
  items: Array<Maybe<ShareContentInput>> | Maybe<ShareContentInput>;
  access_key: Scalars['String'];
}>;


export type PublicShareContentMutation = { publicShareContent?: { results?: Array<{ error?: string | null | undefined, network_id: string, status: SharedStatus, url?: string | null | undefined }> | null | undefined } | null | undefined };

export type SendForgotPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
  client_id?: Maybe<Scalars['ID']>;
}>;


export type SendForgotPasswordEmailMutation = { sendForgotPasswordEmail: string };

export type SendSignOnEmailMutationVariables = Exact<{
  email: Scalars['String'];
  client_id?: Maybe<Scalars['ID']>;
}>;


export type SendSignOnEmailMutation = { sendSignOnEmail: string };

export type SignOnByInvitationMutationVariables = Exact<{
  invitation_id: Scalars['ID'];
}>;


export type SignOnByInvitationMutation = { signOnByInvitation: { token?: string | null | undefined, client: { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, public_post_force_login?: boolean | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, invitation?: { id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number } | null | undefined } };

export type UnsubscribeMutationVariables = Exact<{
  email_address: Scalars['String'];
}>;


export type UnsubscribeMutation = { unsubscribeCE: boolean };

export type GetActiveClientByAttrQueryVariables = Exact<{
  key: UniqueClientKey;
  value: Scalars['String'];
}>;


export type GetActiveClientByAttrQuery = { getActiveClientByAttr?: { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, public_post_force_login?: boolean | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GetAuthAndClientQueryVariables = Exact<{
  email_address: Scalars['String'];
}>;


export type GetAuthAndClientQuery = { getAuthAndClient: { existing_user: boolean, authentication_type?: AuthenticationType | null | undefined, client?: { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, public_post_force_login?: boolean | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } };

export type GetClientsCapabilitiesQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type GetClientsCapabilitiesQuery = { getClientsCapabilities?: Array<{ active?: boolean | null | undefined, capability_string: string } | null | undefined> | null | undefined };

export type GetGlobalSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalSettingsQuery = { getGlobalSettings?: { accepting_signups?: boolean | null | undefined } | null | undefined };

export type GetPublicContentQueryVariables = Exact<{
  content_id: Scalars['ID'];
  client_id: Scalars['ID'];
}>;


export type GetPublicContentQuery = { getPublicContent?: { click_count?: number | null | undefined, content_id: string, comment_count?: number | null | undefined, created_at: number, engagement_count?: number | null | undefined, engage_count?: number | null | undefined, is_engageable?: boolean | null | undefined, is_shareable?: boolean | null | undefined, publish_at: number, reaction_count?: number | null | undefined, share_count?: number | null | undefined, sharing_count?: number | null | undefined, lock_commentary?: boolean | null | undefined, commentary?: Array<{ network: Network, commentary: string } | null | undefined> | null | undefined, user?: { full_name?: string | null | undefined, image?: { width?: number | null | undefined, height?: number | null | undefined, bucket: string, key: string, region: string } | null | undefined } | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id: string } | null | undefined, instagram_metadata?: { id: string, shortcode: string } | null | undefined, reddit_metadata?: { url: string } | null | undefined } } | null | undefined };

export type ListPublicSocialConnectionsQueryVariables = Exact<{
  access_key?: Maybe<Scalars['String']>;
}>;


export type ListPublicSocialConnectionsQuery = { listPublicSocialConnections: { count: number, access_key: string, items: Array<{ expires_soon: boolean, id: string, identifier?: string | null | undefined, profile_url?: string | null | undefined, profile_name?: string | null | undefined, provider: Network, reach?: number | null | undefined }> } };

export const ClientCommonFragmentDoc = `
    fragment ClientCommon on Client {
  id
  title
  subdomain
  email_domains
  content_domains
  client_status
  authentication_type
  allow_user_signup
  departments_in_signup_required
  locations_in_signup_required
  default_timezone
  default_language
  support_multiple_languages
  social_media_policy_enabled
  social_media_policy_title
  social_media_policy
  public_post_page
  public_post_details
  public_post_force_login
  sso_configuration {
    provider
    domain
    identity_pool_id
    user_pool_id
    region
    app_client_id
    redirect_sign_out
  }
  image {
    bucket
    key
    width
    height
    region
  }
}
    `;
export const ClientPublicFragmentDoc = `
    fragment ClientPublic on Client {
  ...ClientCommon
}
    ${ClientCommonFragmentDoc}`;
export const CreatePublicShareInfoDocument = `
    mutation CREATE_PUBLIC_SHARE_INFO($access_key: String!, $content_id: ID!) {
  createPublicShareInfo(access_key: $access_key, content_id: $content_id) {
    shortened_urls {
      email {
        short_link
      }
      direct {
        short_link
      }
      facebook {
        short_link
      }
    }
  }
}
    `;
export const useCreatePublicShareInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePublicShareInfoMutation, TError, CreatePublicShareInfoMutationVariables, TContext>) =>
    useMutation<CreatePublicShareInfoMutation, TError, CreatePublicShareInfoMutationVariables, TContext>(
      'CREATE_PUBLIC_SHARE_INFO',
      (variables?: CreatePublicShareInfoMutationVariables) => transport<CreatePublicShareInfoMutation, CreatePublicShareInfoMutationVariables>(CreatePublicShareInfoDocument, variables)(),
      options
    );
export const EnsureInvitedUserConfirmedDocument = `
    mutation ENSURE_INVITED_USER_CONFIRMED($id: ID!) {
  ensureInvitedUserConfirmed(id: $id) {
    id
    client_id
    email_address
    invitation_status
    created_at
    updated_at
  }
}
    `;
export const useEnsureInvitedUserConfirmedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EnsureInvitedUserConfirmedMutation, TError, EnsureInvitedUserConfirmedMutationVariables, TContext>) =>
    useMutation<EnsureInvitedUserConfirmedMutation, TError, EnsureInvitedUserConfirmedMutationVariables, TContext>(
      'ENSURE_INVITED_USER_CONFIRMED',
      (variables?: EnsureInvitedUserConfirmedMutationVariables) => transport<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>(EnsureInvitedUserConfirmedDocument, variables)(),
      options
    );
export const PublicShareContentDocument = `
    mutation PUBLIC_SHARE_CONTENT($content_id: ID!, $items: [ShareContentInput]!, $access_key: String!) {
  publicShareContent(
    content_id: $content_id
    items: $items
    access_key: $access_key
  ) {
    results {
      error
      network_id
      status
      url
    }
  }
}
    `;
export const usePublicShareContentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublicShareContentMutation, TError, PublicShareContentMutationVariables, TContext>) =>
    useMutation<PublicShareContentMutation, TError, PublicShareContentMutationVariables, TContext>(
      'PUBLIC_SHARE_CONTENT',
      (variables?: PublicShareContentMutationVariables) => transport<PublicShareContentMutation, PublicShareContentMutationVariables>(PublicShareContentDocument, variables)(),
      options
    );
export const SendForgotPasswordEmailDocument = `
    mutation SEND_FORGOT_PASSWORD_EMAIL($email: String!, $client_id: ID) {
  sendForgotPasswordEmail(email: $email, client_id: $client_id)
}
    `;
export const useSendForgotPasswordEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendForgotPasswordEmailMutation, TError, SendForgotPasswordEmailMutationVariables, TContext>) =>
    useMutation<SendForgotPasswordEmailMutation, TError, SendForgotPasswordEmailMutationVariables, TContext>(
      'SEND_FORGOT_PASSWORD_EMAIL',
      (variables?: SendForgotPasswordEmailMutationVariables) => transport<SendForgotPasswordEmailMutation, SendForgotPasswordEmailMutationVariables>(SendForgotPasswordEmailDocument, variables)(),
      options
    );
export const SendSignOnEmailDocument = `
    mutation SEND_SIGN_ON_EMAIL($email: String!, $client_id: ID) {
  sendSignOnEmail(email: $email, client_id: $client_id)
}
    `;
export const useSendSignOnEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendSignOnEmailMutation, TError, SendSignOnEmailMutationVariables, TContext>) =>
    useMutation<SendSignOnEmailMutation, TError, SendSignOnEmailMutationVariables, TContext>(
      'SEND_SIGN_ON_EMAIL',
      (variables?: SendSignOnEmailMutationVariables) => transport<SendSignOnEmailMutation, SendSignOnEmailMutationVariables>(SendSignOnEmailDocument, variables)(),
      options
    );
export const SignOnByInvitationDocument = `
    mutation SIGN_ON_BY_INVITATION($invitation_id: ID!) {
  signOnByInvitation(invitation_id: $invitation_id) {
    client {
      ...ClientPublic
    }
    invitation {
      id
      client_id
      email_address
      invitation_status
      created_at
      updated_at
    }
    token
  }
}
    ${ClientPublicFragmentDoc}`;
export const useSignOnByInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignOnByInvitationMutation, TError, SignOnByInvitationMutationVariables, TContext>) =>
    useMutation<SignOnByInvitationMutation, TError, SignOnByInvitationMutationVariables, TContext>(
      'SIGN_ON_BY_INVITATION',
      (variables?: SignOnByInvitationMutationVariables) => transport<SignOnByInvitationMutation, SignOnByInvitationMutationVariables>(SignOnByInvitationDocument, variables)(),
      options
    );
export const UnsubscribeDocument = `
    mutation UNSUBSCRIBE($email_address: String!) {
  unsubscribeCE(email_address: $email_address)
}
    `;
export const useUnsubscribeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeMutation, TError, UnsubscribeMutationVariables, TContext>) =>
    useMutation<UnsubscribeMutation, TError, UnsubscribeMutationVariables, TContext>(
      'UNSUBSCRIBE',
      (variables?: UnsubscribeMutationVariables) => transport<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, variables)(),
      options
    );
export const GetActiveClientByAttrDocument = `
    query GET_ACTIVE_CLIENT_BY_ATTR($key: UniqueClientKey!, $value: String!) {
  getActiveClientByAttr(key: $key, value: $value) {
    ...ClientPublic
  }
}
    ${ClientPublicFragmentDoc}`;
export const useGetActiveClientByAttrQuery = <
      TData = GetActiveClientByAttrQuery,
      TError = unknown
    >(
      variables: GetActiveClientByAttrQueryVariables,
      options?: UseQueryOptions<GetActiveClientByAttrQuery, TError, TData>
    ) =>
    useQuery<GetActiveClientByAttrQuery, TError, TData>(
      ['GET_ACTIVE_CLIENT_BY_ATTR', variables],
      transport<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>(GetActiveClientByAttrDocument, variables),
      options
    );
useGetActiveClientByAttrQuery.document = GetActiveClientByAttrDocument;


useGetActiveClientByAttrQuery.getKey = (variables: GetActiveClientByAttrQueryVariables) => ['GET_ACTIVE_CLIENT_BY_ATTR', variables];
;

export const GetAuthAndClientDocument = `
    query GET_AUTH_AND_CLIENT($email_address: String!) {
  getAuthAndClient(email_address: $email_address) {
    existing_user
    authentication_type
    client {
      ...ClientPublic
    }
  }
}
    ${ClientPublicFragmentDoc}`;
export const useGetAuthAndClientQuery = <
      TData = GetAuthAndClientQuery,
      TError = unknown
    >(
      variables: GetAuthAndClientQueryVariables,
      options?: UseQueryOptions<GetAuthAndClientQuery, TError, TData>
    ) =>
    useQuery<GetAuthAndClientQuery, TError, TData>(
      ['GET_AUTH_AND_CLIENT', variables],
      transport<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>(GetAuthAndClientDocument, variables),
      options
    );
useGetAuthAndClientQuery.document = GetAuthAndClientDocument;


useGetAuthAndClientQuery.getKey = (variables: GetAuthAndClientQueryVariables) => ['GET_AUTH_AND_CLIENT', variables];
;

export const GetClientsCapabilitiesDocument = `
    query GET_CLIENTS_CAPABILITIES($client_id: ID!) {
  getClientsCapabilities(client_id: $client_id) {
    active
    capability_string
  }
}
    `;
export const useGetClientsCapabilitiesQuery = <
      TData = GetClientsCapabilitiesQuery,
      TError = unknown
    >(
      variables: GetClientsCapabilitiesQueryVariables,
      options?: UseQueryOptions<GetClientsCapabilitiesQuery, TError, TData>
    ) =>
    useQuery<GetClientsCapabilitiesQuery, TError, TData>(
      ['GET_CLIENTS_CAPABILITIES', variables],
      transport<GetClientsCapabilitiesQuery, GetClientsCapabilitiesQueryVariables>(GetClientsCapabilitiesDocument, variables),
      options
    );
useGetClientsCapabilitiesQuery.document = GetClientsCapabilitiesDocument;


useGetClientsCapabilitiesQuery.getKey = (variables: GetClientsCapabilitiesQueryVariables) => ['GET_CLIENTS_CAPABILITIES', variables];
;

export const GetGlobalSettingsDocument = `
    query GET_GLOBAL_SETTINGS {
  getGlobalSettings {
    accepting_signups
  }
}
    `;
export const useGetGlobalSettingsQuery = <
      TData = GetGlobalSettingsQuery,
      TError = unknown
    >(
      variables?: GetGlobalSettingsQueryVariables,
      options?: UseQueryOptions<GetGlobalSettingsQuery, TError, TData>
    ) =>
    useQuery<GetGlobalSettingsQuery, TError, TData>(
      variables === undefined ? ['GET_GLOBAL_SETTINGS'] : ['GET_GLOBAL_SETTINGS', variables],
      transport<GetGlobalSettingsQuery, GetGlobalSettingsQueryVariables>(GetGlobalSettingsDocument, variables),
      options
    );
useGetGlobalSettingsQuery.document = GetGlobalSettingsDocument;


useGetGlobalSettingsQuery.getKey = (variables?: GetGlobalSettingsQueryVariables) => variables === undefined ? ['GET_GLOBAL_SETTINGS'] : ['GET_GLOBAL_SETTINGS', variables];
;

export const GetPublicContentDocument = `
    query GET_PUBLIC_CONTENT($content_id: ID!, $client_id: ID!) {
  getPublicContent(content_id: $content_id, client_id: $client_id) {
    click_count
    content_id
    comment_count
    created_at
    engagement_count
    engage_count
    is_engageable
    is_shareable
    publish_at
    reaction_count
    share_count
    sharing_count
    lock_commentary
    commentary {
      network
      commentary
    }
    user {
      full_name
      image {
        width
        height
        bucket
        key
        region
      }
    }
    content_object {
      post_type
      metadata_keys
      title
      body
      url
      photos {
        bucket
        key
        width
        height
        region
      }
      media {
        video {
          bucket
          key
          region
          playlist
          poster
          thumbnails
          status
        }
      }
      url_metadata {
        provider_display
        provider_name
        provider_url
        title
        url
        original_url
        description
        images {
          url
          bucket
          file_key
          url_proxy
          url_original
          caption
          height
          width
          size
          primary
        }
        media {
          duration
          height
          width
          type
          html
          url
          bucket
          file_key
          url_proxy
          url_original
        }
      }
      tweet_metadata {
        id_str
        created_at
        text
        favorite_count
        retweet_count
        user {
          name
          screen_name
          profile_image_url_https
          verified
        }
        hashtags {
          text
        }
        urls {
          display_url
          expanded_url
        }
        user_mentions {
          id_str
          name
          screen_name
        }
        media {
          media_url_https
          type
        }
      }
      youtube_metadata {
        video_id
      }
      instagram_metadata {
        id
        shortcode
      }
      reddit_metadata {
        url
      }
    }
  }
}
    `;
export const useGetPublicContentQuery = <
      TData = GetPublicContentQuery,
      TError = unknown
    >(
      variables: GetPublicContentQueryVariables,
      options?: UseQueryOptions<GetPublicContentQuery, TError, TData>
    ) =>
    useQuery<GetPublicContentQuery, TError, TData>(
      ['GET_PUBLIC_CONTENT', variables],
      transport<GetPublicContentQuery, GetPublicContentQueryVariables>(GetPublicContentDocument, variables),
      options
    );
useGetPublicContentQuery.document = GetPublicContentDocument;


useGetPublicContentQuery.getKey = (variables: GetPublicContentQueryVariables) => ['GET_PUBLIC_CONTENT', variables];
;

export const ListPublicSocialConnectionsDocument = `
    query LIST_PUBLIC_SOCIAL_CONNECTIONS($access_key: String) {
  listPublicSocialConnections(access_key: $access_key) {
    count
    items {
      expires_soon
      id
      identifier
      profile_url
      profile_name
      provider
      reach
    }
    access_key
  }
}
    `;
export const useListPublicSocialConnectionsQuery = <
      TData = ListPublicSocialConnectionsQuery,
      TError = unknown
    >(
      variables?: ListPublicSocialConnectionsQueryVariables,
      options?: UseQueryOptions<ListPublicSocialConnectionsQuery, TError, TData>
    ) =>
    useQuery<ListPublicSocialConnectionsQuery, TError, TData>(
      variables === undefined ? ['LIST_PUBLIC_SOCIAL_CONNECTIONS'] : ['LIST_PUBLIC_SOCIAL_CONNECTIONS', variables],
      transport<ListPublicSocialConnectionsQuery, ListPublicSocialConnectionsQueryVariables>(ListPublicSocialConnectionsDocument, variables),
      options
    );
useListPublicSocialConnectionsQuery.document = ListPublicSocialConnectionsDocument;


useListPublicSocialConnectionsQuery.getKey = (variables?: ListPublicSocialConnectionsQueryVariables) => variables === undefined ? ['LIST_PUBLIC_SOCIAL_CONNECTIONS'] : ['LIST_PUBLIC_SOCIAL_CONNECTIONS', variables];
;
